/* NEW page behaviour (sections/csl-new-arrivals.liquid)
   - brand / search / video filters + sorting of the server-rendered cards
   - YouTube modal (privacy-enhanced embed)
   - count-up stats, reveal-on-scroll, spotlight scroller
   - "Compare" tray backed by localStorage (shared with the Compare page)     */
(function () {
  'use strict';
  var STORAGE_KEY = 'csl-compare-v1';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function readCompare() {
    try { var v = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function writeCompare(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch (e) { /* storage blocked */ }
  }

  function init(root) {
    if (!root || root.dataset.cnReady) return;
    root.dataset.cnReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
    var grid = root.querySelector('[data-grid]');
    var search = root.querySelector('[data-search]');
    var sort = root.querySelector('[data-sort]');
    var videoFilter = root.querySelector('[data-video-filter]');
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-brand-chips] [data-brand]'));
    var status = root.querySelector('[data-count-status]');
    var empty = root.querySelector('[data-empty]');
    var state = { brand: '', q: '', video: false, sort: 'newest' };
    var total = cards.length;

    /* brand chip counts */
    var counts = {};
    cards.forEach(function (c) { var v = c.dataset.vendor; counts[v] = (counts[v] || 0) + 1; });
    chips.forEach(function (chip) {
      var n = chip.querySelector('[data-brand-count]');
      if (n && chip.dataset.brand) n.textContent = counts[chip.dataset.brand] || 0;
    });

    function matches(card) {
      if (state.brand && card.dataset.vendor !== state.brand) return false;
      if (state.video && card.dataset.video !== '1') return false;
      if (state.q) {
        var hay = (card.dataset.title + ' ' + card.dataset.vendor + ' ' + card.dataset.type + ' ' + card.dataset.sku).toLowerCase();
        var terms = state.q.split(/\s+/).filter(Boolean);
        for (var i = 0; i < terms.length; i++) if (hay.indexOf(terms[i]) === -1) return false;
      }
      return true;
    }
    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var ok = matches(card);
        card.hidden = !ok;
        if (ok) shown++;
      });
      if (status) status.textContent = shown + ' of ' + total + ' products';
      if (empty) empty.hidden = shown !== 0;
    }
    function sortCards() {
      var key = state.sort;
      var sorted = cards.slice().sort(function (a, b) {
        switch (key) {
          case 'price-asc': return (+a.dataset.price) - (+b.dataset.price);
          case 'price-desc': return (+b.dataset.price) - (+a.dataset.price);
          case 'title': return a.dataset.title.localeCompare(b.dataset.title);
          case 'brand': return a.dataset.vendor.localeCompare(b.dataset.vendor) || a.dataset.title.localeCompare(b.dataset.title);
          default: return (+a.dataset.index) - (+b.dataset.index);
        }
      });
      sorted.forEach(function (c, i) { c.style.setProperty('--i', i % 12); grid.appendChild(c); });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.brand = chip.dataset.brand || '';
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        apply();
      });
    });
    if (search) {
      var t;
      search.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { state.q = search.value.trim().toLowerCase(); apply(); }, 120);
      });
    }
    if (sort) sort.addEventListener('change', function () { state.sort = sort.value; sortCards(); apply(); });
    if (videoFilter) {
      videoFilter.addEventListener('click', function () {
        state.video = !state.video;
        videoFilter.setAttribute('aria-pressed', state.video ? 'true' : 'false');
        apply();
      });
    }

    /* deep links: ?brand=…  ?q=… */
    try {
      var params = new URLSearchParams(location.search);
      if (params.get('brand')) {
        var want = params.get('brand').toLowerCase();
        chips.forEach(function (chip) { if (chip.dataset.brand && chip.dataset.brand.toLowerCase() === want) chip.click(); });
      }
      if (params.get('q') && search) { search.value = params.get('q'); state.q = params.get('q').toLowerCase(); apply(); }
    } catch (e) { /* ignore */ }

    /* ---- video modal ---- */
    var modal = root.querySelector('[data-video-modal]');
    var frame = root.querySelector('[data-video-frame]');
    var modalTitle = root.querySelector('[data-video-modal-title]');
    var lastFocus = null;
    function openVideo(id, title) {
      if (!modal || !frame || !id) return;
      lastFocus = document.activeElement;
      frame.innerHTML = '';
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.title = title || 'Product video';
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      frame.appendChild(iframe);
      if (modalTitle) modalTitle.textContent = title || '';
      if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
      document.documentElement.classList.add('cn-modal-open');
    }
    function closeVideo() {
      if (!modal) return;
      if (frame) frame.innerHTML = '';
      if (modal.open && typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open');
      document.documentElement.classList.remove('cn-modal-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    root.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-video-open]');
      if (opener) { e.preventDefault(); openVideo(opener.dataset.videoId, opener.dataset.videoTitle); return; }
      if (e.target.closest('[data-video-close]')) { e.preventDefault(); closeVideo(); }
    });
    if (modal) {
      modal.addEventListener('click', function (e) { if (e.target === modal) closeVideo(); });
      modal.addEventListener('close', function () { if (frame) frame.innerHTML = ''; document.documentElement.classList.remove('cn-modal-open'); });
      modal.addEventListener('cancel', function (e) { e.preventDefault(); closeVideo(); });
    }

    /* ---- spotlight scroller arrows ---- */
    var track = root.querySelector('[data-spot-track]');
    var prev = root.querySelector('[data-spot-prev]');
    var next = root.querySelector('[data-spot-next]');
    if (track && prev && next) {
      function step() { var card = track.querySelector('[data-spot-card]'); return card ? card.getBoundingClientRect().width + 16 : 400; }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      function arrows() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      track.addEventListener('scroll', arrows, { passive: true });
      window.addEventListener('resize', arrows);
      arrows();
    }

    /* ---- count-up ---- */
    var counters = root.querySelectorAll('[data-count]');
    if (counters.length && !reduce && 'IntersectionObserver' in window) {
      var cio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target, end = parseInt(el.dataset.count, 10) || 0, start = performance.now(), dur = 1100;
          cio.unobserve(el);
          (function tick(now) {
            var p = Math.min(1, (now - start) / dur), eased = 1 - Math.pow(1 - p, 3);
            el.textContent = Math.round(end * eased);
            if (p < 1) requestAnimationFrame(tick);
          })(start);
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { cio.observe(el); });
    }

    /* ---- reveal on scroll ---- */
    var reveals = root.querySelectorAll('.cs-reveal');
    if (reveals.length && 'IntersectionObserver' in window && !reduce) {
      var rio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); rio.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      reveals.forEach(function (el) { rio.observe(el); });
      /* safety: never leave content hidden */
      setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-in'); }); }, 2500);
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* ---- compare tray ---- */
    var tray = root.querySelector('[data-compare-tray]');
    var max = parseInt(root.dataset.compareMax, 10) || 4;
    var compareUrl = root.dataset.compareUrl || '/pages/compare';
    function renderCompare() {
      var list = readCompare();
      var handles = list.map(function (p) { return p.handle; });
      root.querySelectorAll('[data-compare-toggle]').forEach(function (btn) {
        var on = handles.indexOf(btn.dataset.handle) !== -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = btn.querySelector('[data-compare-label]');
        if (label) label.textContent = on ? 'Added ✓' : 'Compare';
      });
      if (!tray) return;
      tray.hidden = list.length === 0;
      var count = tray.querySelector('[data-compare-count]');
      var names = tray.querySelector('[data-compare-names]');
      var open = tray.querySelector('[data-compare-open]');
      if (count) count.textContent = list.length;
      if (names) names.textContent = list.map(function (p) { return p.title; }).join(' · ');
      if (open) open.href = compareUrl + '?products=' + encodeURIComponent(handles.join(','));
    }
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-compare-toggle]');
      if (btn) {
        var list = readCompare();
        var idx = list.findIndex(function (p) { return p.handle === btn.dataset.handle; });
        if (idx === -1) {
          if (list.length >= max) { list.shift(); }
          list.push({ handle: btn.dataset.handle, title: btn.dataset.title });
        } else {
          list.splice(idx, 1);
        }
        writeCompare(list);
        renderCompare();
      }
      if (e.target.closest('[data-compare-clear]')) { writeCompare([]); renderCompare(); }
    });
    window.addEventListener('storage', function (e) { if (e.key === STORAGE_KEY) renderCompare(); });
    renderCompare();
  }

  function boot() { document.querySelectorAll('[data-cn]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var el = e.target && e.target.querySelector && e.target.querySelector('[data-cn]'); if (el) { delete el.dataset.cnReady; init(el); } });
})();
